class optionalItems extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkbox.addEventListener('change', this.checkInputChecked.bind(this));
    });
    this.checkInputChecked();
  }

  checkInputChecked() {
    const checkboxes = this.querySelectorAll('input[type="checkbox"]');
    let checkedCount = 0;
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        checkedCount++;
      }
    });
    if (checkedCount > 0) {
      let totalCount = checkedCount + 1; // +1 for the main product
      document.querySelector('.product-form [type="submit"]').querySelector('span').textContent = window.variantStrings.addToCartWithItems.replace(
        /<span>(.*?)<\/span>/,
        `${totalCount}`
      );
    } else {
      document.querySelector('.product-form [type="submit"]').querySelector('span').textContent = window.variantStrings.addToCart;
    }
  }

}

customElements.define('optional-items', optionalItems);